import { render, staticRenderFns } from "./DocumentTemplateHeader.vue?vue&type=template&id=633b7cc2&scoped=true&lang=pug&"
import script from "./DocumentTemplateHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplateHeader.vue?vue&type=style&index=0&id=633b7cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b7cc2",
  null
  
)

/* custom blocks */
import block0 from "./DocumentTemplateHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VIcon,VImg,VProgressCircular,VRow,VSkeletonLoader,VSpacer,VTextField})
